import React, { useState, useEffect } from 'react';
import { formatText, linkify } from '../../utility/MessageFormatter';

const TypingEffect = ({ text, speed = 100,setIsTyping, scrollToBottom }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [index, setIndex] = useState(0);
    const [textSize, setTextSize] = useState(40)
    useEffect(() => {
        if (index < text.length) {
            // setIsTyping(true)
            const timeoutId = setTimeout(() => {
                setDisplayedText((prev) => prev + text.charAt(index));
                setIndex((prev) => prev + 1);
            }, speed);

            return () => clearTimeout(timeoutId);  // Clean up the timeout
        }
    }, [index, text, speed]);

    useEffect(()=>{
        if (index === text.length) {
            setIsTyping(true)
            setTimeout(()=>{
                scrollToBottom()
            },600)
        }
        if(index === textSize){
            setTextSize(textSize+40)
            scrollToBottom()
        }
    },[index])

    return <div dangerouslySetInnerHTML={{ __html: linkify(formatText(displayedText)) }}></div>;
};

export default TypingEffect;
